/* LUVA header: announcement rotation, mega menu, mobile drawer, header height variables.
   No dependencies. Runs once per page load and again for the theme editor section reloads. */
(function () {
  'use strict';

  var HOVER_IN = 90;
  var HOVER_OUT = 220;

  function measure() {
    var header = document.getElementById('header-component');
    var group = document.getElementById('header-group');
    if (!header || !group) return;
    var groupHeight = 0;
    for (var i = 0; i < group.children.length; i++) {
      groupHeight += group.children[i].offsetHeight;
    }
    document.body.style.setProperty('--header-height', header.offsetHeight + 'px');
    document.body.style.setProperty('--header-group-height', groupHeight + 'px');
    /* Fixed LUVA header section height (includes gut padding around the pill). */
    var section = document.querySelector('.luva-header-section');
    if (section) {
      var off = Math.ceil(section.getBoundingClientRect().height);
      document.body.style.setProperty('--luva-fixed-header-offset', off + 'px');
    }
  }

  function initAnnouncement(root) {
    var items = root.querySelectorAll('.luva-ann__item');
    if (items.length < 2) return;
    var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
    var idx = 0;
    if (root._luvaTimer) clearInterval(root._luvaTimer);
    root._luvaTimer = setInterval(function () {
      items[idx].classList.remove('is-on');
      idx = (idx + 1) % items.length;
      items[idx].classList.add('is-on');
    }, interval);
  }

  function initHeader(header) {
    var open = null;
    var timer = null;
    var touch = window.matchMedia('(hover: none)').matches;

    function panelFor(id) {
      return header.querySelector('[data-luva-mega-panel="' + id + '"]');
    }

    function hide() {
      header.querySelectorAll('.is-open').forEach(function (el) {
        el.classList.remove('is-open');
      });
      header.querySelectorAll('[data-luva-mega] > a[aria-expanded]').forEach(function (a) {
        a.setAttribute('aria-expanded', 'false');
      });
      open = null;
    }

    function show(id) {
      hide();
      var li = header.querySelector('[data-luva-mega="' + id + '"]');
      var panel = panelFor(id);
      if (!li || !panel) return;
      li.classList.add('is-open');
      panel.classList.add('is-open');
      li.querySelector('a').setAttribute('aria-expanded', 'true');
      open = id;
    }

    header.querySelectorAll('[data-luva-mega]').forEach(function (li) {
      var id = li.getAttribute('data-luva-mega');
      var link = li.querySelector('a');
      link.setAttribute('aria-expanded', 'false');
      link.setAttribute('aria-haspopup', 'true');

      li.addEventListener('mouseenter', function () {
        clearTimeout(timer);
        timer = setTimeout(function () { show(id); }, HOVER_IN);
      });
      li.addEventListener('mouseleave', function () {
        clearTimeout(timer);
        timer = setTimeout(hide, HOVER_OUT);
      });
      link.addEventListener('click', function (e) {
        if (touch) {
          e.preventDefault();
          open === id ? hide() : show(id);
        }
      });
      link.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === ' ') {
          e.preventDefault();
          show(id);
          var first = panelFor(id).querySelector('a');
          if (first) first.focus();
        }
      });
    });

    header.querySelectorAll('[data-luva-mega-panel]').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () { clearTimeout(timer); });
      panel.addEventListener('mouseleave', function () { timer = setTimeout(hide, HOVER_OUT); });
      panel.addEventListener('focusout', function (e) {
        if (!panel.contains(e.relatedTarget) && !header.contains(e.relatedTarget)) hide();
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') hide();
    });
    document.addEventListener('click', function (e) {
      if (open && !header.contains(e.target)) hide();
    });

    // Mobile drawer
    var drawer = header.parentElement.querySelector('[data-luva-drawer]');
    var opener = header.querySelector('[data-luva-drawer-open]');
    if (drawer && opener) {
      var closer = drawer.querySelector('[data-luva-drawer-close]');

      // Die Schublade ist ein Dialog mit aria-modal. Ohne Fangschleife wandert
      // der Fokus nach fuenf Tabs in die Seite dahinter, die gar nicht sichtbar
      // ist. Tab bleibt deshalb innerhalb der Schublade.
      var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

      function trappable() {
        return Array.prototype.filter.call(drawer.querySelectorAll(FOCUSABLE), function (el) {
          return el.offsetWidth > 0 || el.offsetHeight > 0 || el === document.activeElement;
        });
      }

      function onTrapKey(e) {
        if (e.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
        var list = trappable();
        if (!list.length) return;
        var first = list[0];
        var last = list[list.length - 1];
        if (!drawer.contains(document.activeElement)) {
          e.preventDefault();
          first.focus();
          return;
        }
        if (e.shiftKey && document.activeElement === first) {
          e.preventDefault();
          last.focus();
        } else if (!e.shiftKey && document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }

      function openDrawer() {
        drawer.classList.add('is-open');
        drawer.removeAttribute('inert');
        opener.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('luva-drawer-open');
        document.addEventListener('keydown', onTrapKey, true);
        if (closer) closer.focus();
      }
      function closeDrawer() {
        drawer.classList.remove('is-open');
        drawer.setAttribute('inert', '');
        opener.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('luva-drawer-open');
        document.removeEventListener('keydown', onTrapKey, true);
        opener.focus();
      }
      drawer.setAttribute('inert', '');
      opener.addEventListener('click', openDrawer);
      if (closer) closer.addEventListener('click', closeDrawer);
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
      });
      drawer.querySelectorAll('[data-luva-acc]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var expanded = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', expanded ? 'false' : 'true');
          var list = document.getElementById(btn.getAttribute('aria-controls'));
          if (list) list.hidden = expanded;
        });
      });
    }

    // Scrolled state for the floating pill
    var scrolled = false;
    var wrapper = document.querySelector('.page-wrapper');
    function onScroll() {
      var y = Math.max(window.scrollY, wrapper ? wrapper.scrollTop : 0);
      var s = y > 8;
      if (s !== scrolled) {
        scrolled = s;
        header.classList.toggle('is-scrolled', s);
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    if (wrapper) wrapper.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  /* Desktop squeeze mode has no ::backdrop — close open theme-drawers when
     the shopper clicks the shop area outside the dialog. Modal (<990px) already
     closes via native backdrop + theme-drawer #onBackdropClick. */
  function initDrawerOutsideClose() {
    if (document.documentElement._luvaDrawerOutside) return;
    document.documentElement._luvaDrawerOutside = true;
    document.addEventListener('pointerdown', function (e) {
      var drawer = document.querySelector('theme-drawer[open]');
      if (!drawer || typeof drawer.close !== 'function') return;
      var panel = drawer.querySelector('dialog');
      if (!panel || !panel.open) return;
      try {
        if (panel.matches(':modal')) return;
      } catch (_) {}
      if (panel.contains(e.target)) return;
      if (e.target.closest && (
        e.target.closest('[data-testid="cart-drawer-trigger"]') ||
        e.target.closest('[aria-controls="cart-drawer"]')
      )) return;
      drawer.close();
    }, true);
  }

  function init() {
    initDrawerOutsideClose();
    document.querySelectorAll('[data-luva-ann]').forEach(initAnnouncement);
    var header = document.getElementById('header-component');
    if (header && header.hasAttribute('data-luva-header') && !header._luvaInit) {
      header._luvaInit = true;
      initHeader(header);
    }
    measure();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  window.addEventListener('resize', measure);
  window.addEventListener('load', measure);
  document.addEventListener('shopify:section:load', init);
})();
